/**
 * Pure helpers for category display ordering.
 *
 * Display order is authoritative on the admin-set `sort_order` (with `id` as a stable tiebreak),
 * NOT the order categories happen to arrive in from the API — that varies by fetch path (the staff
 * list comes back already sorted, while the per-org admin merge comes back in numeric-id order).
 */

// Sort categories by sort_order, then id. Non-mutating.
export function sortCategoriesByOrder(categories) {
  return [...(categories || [])].sort(
    (a, b) => ((a.sort_order ?? 0) - (b.sort_order ?? 0)) || (a.id - b.id)
  );
}

// Move `catId` to the 1-based position `newPos` within the given (display-ordered) list and
// return the resulting array of ids. Returns null for a no-op (unknown id, or already there).
export function computeReorder(categories, catId, newPos) {
  const cats = [...(categories || [])];
  const curIdx = cats.findIndex((c) => c.id === catId);
  const target = Math.max(0, Math.min(cats.length - 1, Number(newPos) - 1));
  if (curIdx === -1 || curIdx === target) return null;
  const [moved] = cats.splice(curIdx, 1);
  cats.splice(target, 0, moved);
  return cats.map((c) => c.id);
}
